import React from 'react';
import { observer } from 'mobx-react'
import { LiveStream, ProgressStateModel } from 'eTip--common';
import { IMatchTrackerSelectionItem as IMatchTrackerWithSelectionItem, MatchTrackerSelection, MatchTracker } from 'desktop--design-library';
import { MatchTrackerShowType } from '../../models/live/liveStreamRightSideWrapper';
import { Instance } from 'mobx-state-tree';

export interface IMatchTrackerWithSelectionProps {
    info: Instance<typeof LiveStream>;
    availableEvents: Map<number, IMatchTrackerWithSelectionItem>;
    showType: MatchTrackerShowType;
    matchTrackerKey: string;
    onOpen: (item: IMatchTrackerWithSelectionItem) => void;
    onClose: () => void;
}

export const MatchTrackerWithSelection = observer((props: IMatchTrackerWithSelectionProps) => {
    return props.info && props.info.state != ProgressStateModel.NotInitialized /* on close later called videoStoppedForMonitoring */ &&
        <div className="addShadow sideControl mb-2 match-tracker">
            {
                <div>
                    <MatchTrackerSelection
                        graphicsPresentationId={props.info.graphicsPresentationId}
                        eventName={props.info.eventName}
                        availableEvents={[...Array.from(props.availableEvents.values())]}
                        onClose={() => { props.onClose() }}
                        onOpen={(event: IMatchTrackerWithSelectionItem) => { props.onOpen(event) }}
                    />
                    <MatchTracker
                        state={props.info.state}
                        externalId={props.info.externalId}
                        operator={props.info.operator}
                        elementIdBase="matchtracker-right-col"
                        eventName={props.info.eventName}
                        errorLoadingContent={props.info.setErrorWhenShown}
                        languageId={props.info.languageId}
                        prepareUrlsAsync={props.info.prepareUrlsAsync}
                        matchTrackerKey={props.matchTrackerKey}
                        shownForMonitoring={props.info.videoShownForMonitoring}
                        stoppedForMonitoring={props.info.videoStoppedForMonitoring}
                    />

                </div>
            }
        </div >
})